import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateFilter' })
export class DateFilterPipe implements PipeTransform {
    transform(items: any[], term: string): any[] {
        if (!items || !term) return items;
        return items.filter(item => 
            new Date(item.timeStamp).toISOString().includes(term)
        );
    }
}